import React, { Component } from 'react';
import { TextField, RaisedButton } from 'material-ui';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import './PasswordReset.css';
import '../Login/Login.css';
import ImagePadlock from '../../Assets/Images/padlock.svg';
import getMuiTheme from 'material-ui/styles/getMuiTheme';


const muiTheme = getMuiTheme({
  fontFamily: 'Open Sans',
});

const passwordResetStyle = {
  color: '#55aef6',
  borderColor: '#55aef6'
};

export default class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      responseCode: '',
    };
    this.getEmailValue = this.getEmailValue.bind(this);
  }
  /* Save user typed email to state. */
  getEmailValue = (event) => {
    this.setState({
      email: event.target.value,
    })
  };
  /* Service for password reset  */
  resetPassword() {

    let data = {
      email: this.state.email,
    };

    /*  Path for email that will lead to confirmation component. */
    let protocol = window.location.protocol;
    let slashes = protocol.concat("//");
    let host = slashes.concat(window.location.hostname);
    let referrerPath = host + '/reset-password/confirm';
    fetch(`${process.env.REACT_APP_API_HOST}user/change_password/request`, {
      body: JSON.stringify(data),
      method: 'POST',
      headers: {
        'X-Referer': referrerPath,
        'Access-Control-Allow-Origin': '*',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then(response => {
        // Set the response status code to be later used for message display.
        this.setState({ responseCode: response.status });
      })
  }

  render() {
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div className="password-reset-main loginForm">
          <div className="emailform-wrapper loginForm-inner">
            <h2 className="password-reset-title">Za promenu lozinke je potrebna email adresa registrovana na Vašem nalogu!</h2>
            <img className="password-reset-logo" alt="" src={ImagePadlock} />
            <TextField
              floatingLabelText={"Molimo unesite vašu email adresu :"}
              floatingLabelFixed={true}
              floatingLabelFocusStyle={passwordResetStyle}
              underlineFocusStyle={passwordResetStyle}
              onChange={this.getEmailValue}
              className="email-input"
            />
            <RaisedButton
              label={"Pošalji"}
              className="password-reset-submit"
              style={{ display: "block" }}
              backgroundColor="#90caf9"
              labelColor="#ffffff"
              onClick={this.resetPassword.bind(this)}
            />
            {/* Message in case the given email does not exist */}
            {this.state.responseCode === 400 ?
              <p className="password-validation-message">Korisnik sa datom adresom ne postoji!</p> : null}
            {/* Message if something went wrong. */}
            {this.state.responseCode === 500 ?
              <p className="password-validation-message">Slanje maila nije uspelo! Pokušajte ponovo.</p> : null}
            {/* Message on success. */}
            {this.state.responseCode === 200 ?
              <p className="login-password-message">Vaš zahtev je uspešno poslat!</p> : null}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}




// WEBPACK FOOTER //
// ./src/Components/PasswordReset/PasswordReset.jsx